import React, { Component } from 'react';

import { Container, Row, Col } from 'react-bootstrap';

import * as fn from '../library/function';
import * as constants from '../config/constants/AppConstants';
import * as helper from '../library/helper';
import * as util from '../library/utilitys';

import CommonPageHeader from './components/CommonPageHeader';
import CommonToolbar from './components/CommonToolbar';
import CommonToast from './components/CommonToast';
import CommonConfirmModal from './components/CommonConfirmModal';
import CommonPreviewFileModal from './components/CommonPreviewFileModal';

import CommonTokenExpired from './components/CommonTokenExpired';

import Cookies from "js-cookie";

/** withRouter */
import withRouter from "./components/withRouter"

/** start individual component */
import InputEB01DataCourse from './inputs/InputEB01DataCourse';
import SearchEB01DataCourse from './searchs/SearchEB01DataCourse';
import DataTableEB01DataCourse from './dataTables/DataTableEB01DataCourse';
/** end individual component */

import * as Actions from './actions/ActionCenter';

import { GlobalStates } from './states/GlobalStates';

/** individual page state */
import { PageDataState } from './states/EB01DataCourseEB01State';

/** requester handle */
import requester from "../library/Requester"; 

/** define end point */
const TABLE = `course_eb_01`;
const URL = `api/master/${TABLE}`;

const rawProfile = Cookies.get("userProfile");
const userProfile = rawProfile ? JSON.parse(rawProfile) : {};

let GET_OFFICIAL_COURSE_CODE = `api/master/get-official-course-type-b-code/`; 
let GET_ALL_COURSE_STATUS = `api/master/get-official-course-all-code/`; // view_export_eb1_status

class EB01DataCourse extends Component {

    constructor(props){
        super(props);

        this.state = {...GlobalStates, ...PageDataState};
        this.updateState = this.setState.bind(this);
    }

    initialize = async () => {
        await this.loadMasterbase();
        await this.loadDataTable();
        await this.setDefaultSearchs();
    }

    loadMasterbase = async () => {
        let sets = [
            {key: "academy", filter: [{field: "status", value: "0"}]},
            {key: "enterprise", filter: [{field: "status", value: "0"}]},
            {key: 'benefits', filter: [{field: "status", value: "0"}]},
            {key: 'target_industries', filter: [{field: "status", value: "0"}]},
        ]; 
        Actions.loadMasterbase(this.updateState, sets);
    }

    loadDataTable = async (search = false) => {
        const { Searchs, DataTable } = this.state;

        const cookieSearchs = {};
        
        if (userProfile.academy_id && !["0","1"].includes(userProfile.types))  {
            cookieSearchs.academy_id = { id: "academy_id", value: userProfile.academy_id };
        }
        
        const mergedSearchs = {
            ...Searchs,
            ...cookieSearchs,
            page: {
                id: "page",
                value: search ? 1 : DataTable.pagination.currentPage,
            },
        };

        await Actions.loadDataTable(
            this.updateState,
            `${URL}/pagination`,
            fn.getInputSearch(mergedSearchs)
        );
    }

    setDefaultSearchs = async () => {
        let defaultsSearchs = {};
         switch (userProfile.types) {
            case "2": // academy
                defaultsSearchs.academy_id = userProfile.academy_id;
            break;
            default:
                //(admin) ไม่เซ็ตค่า
            break;
        }
        await Actions.setDefaultSearchs(this.updateState,defaultsSearchs);
        
    }
    
    navigate = (e = {}, obj = {}) => {
        const { Searchs, DataTable, Operation } = this.state; 
                
        const key = 'course_eb_01';

        Actions.navigate(this.props.navigate, "/apps/" + e.target.value , {
            direction: 'drilldown',
            key: key,
            restore: {},
            [key]: {
                parameters: {...obj},
                searchs: Searchs,
                operation: Operation,
                currentPage: DataTable.pagination.currentPage,
            },
        });
    };

    updateSomething = async (obj, element, pk) => {
        await Actions.updateSomething(this.updateState, `${URL}/update-something`, element, pk, obj, this.loadDataTable);
    }

    fetchForEdit = async (obj, approved = false) => {
        await Actions.fetchForEdit(
            this.updateState,
            `${URL}/${obj.id}`, 
            {element: 'OffCanvas', mode: 'update', bool: true},
            this.state.Inputs
        );

        this.resetApproved(approved);
    }

    deleteData = async () => {
        const { Deletes } = this.state;
        await Actions.deleteData(this.updateState, `${URL}`, Deletes, this.loadDataTable);
        await this.resetApproved(false);
    }

    submitData = async () => {
        const { Action, Inputs, DataTable } = this.state; 
        await Actions.submitData(
            this.updateState,
            `${URL}`,
            Action.Mode, 
            fn.getInputForm({...Inputs}),
            this.loadDataTable,
            null,
            this.state.Inputs
        );
        await this.resetApproved(false);
    }

    setDefaultInputs = async () => {
        await Actions.setProfileInputs(this.updateState, {
            academy_id: "academy_id",
        });
    }

    parametersControl = async (state) => {
        if (state) {
            const { direction, key, restore, ...object } = state;
            await Actions.parametersPrompt(this.updateState, key, object[key], restore);
            this.setDefaultInputs();
        }
    
        const shouldInitialize = !!state; 
        if (shouldInitialize) {
            await this.initialize();
        }
    };

    generateCourseCode = async (e) => {
        if(this.state.Inputs.course_type.value === 'c'){
            GET_OFFICIAL_COURSE_CODE = `api/master/get-official-course-type-c-code/`;
        }else if(this.state.Inputs.course_type.value === 't'){
            GET_OFFICIAL_COURSE_CODE = `api/master/get-official-course-type-t-code/`;
        }else{            
            GET_OFFICIAL_COURSE_CODE = `api/master/get-official-course-type-b-code/`; 
        }
        let {id} = e;
        let result = await Actions.getSomething(this.updateState, GET_OFFICIAL_COURSE_CODE + id , {});
        if(result.success){
            this.updateSomething({target: {name: 'official_course_code', value: result.data}}, 'DataTable', {key: "id", value: id} );
        }
    }

    // exportExcel = async () => {
        
    //     let result = await Actions.getSomething(this.updateState, GET_OFFICIAL_COURSE_CODE + id , {});
    //     // const { Searchs, DataTable } = this.state;

    //     // const cookieSearchs = {};
    //     //  const mergedSearchs = {
    //     //     ...Searchs,
    //     //     ...cookieSearchs,
    //     //     page: {
    //     //         id: "page",
    //     //         value: 1,
    //     //     },
    //     // };

    //     // await Actions.loadDataTable(
    //     //     // this.updateState,
    //     //     `${URL}/pagination`,
    //     //     fn.getInputSearch(mergedSearchs)
    //     // );
        
    //     const { Action, Inputs, DataTable } = this.state;

    //     await requester.get(
    //         `${URL}/pagination`,
    //         { currentPage: 2, pageSize: 10000 },
    //         {
    //             headers: { 
    //                 "X-CSRF-Token": this.state.csrfToken,
    //                 "Content-Type": "json/application"
    //             }
    //         }
    //     )
    //     .then( async (response) => {
    //             console.log("response", response);
    //         // if(response?.data?.success === true){
    //         //     await Actions.submitData(
    //         //         this.updateState,
    //         //         `${URL}`,
    //         //         Action.Mode, 
    //         //         fn.getInputForm({...Inputs}),
    //         //         this.loadDataTable
    //         //     );
    //         // }else if(response?.data?.success === false){
    //         //     this.setState({ error: response?.data?.message, showModal: true }, () => {
    //         //         util.debug(this.state, 'GET-TOKEN-AND-USER-PROCESS-FAIL');
    //         //     });  
    //         // }else{
    //         //     this.setState({ error: response?.data?.errors, showModal: true }, () => {
    //         //         util.debug(this.state, 'GET-TOKEN-AND-USER-PROCESS-FAIL');
    //         //     });            
    //         // }
    //     })
    //     .catch((error) => {
    //         console.log("error", error?.response?.data?.error);            
    //     });
    // }

    resetApproved = async (approved) => {
        this.updateState(
            (prevState) => ({
                ...prevState,
                Approved: approved
            })
        );        
    }

    componentDidMount = async () => {
        const state = this.props.location.state || {} ;
        
        if (util.isObject(state)){
            this.parametersControl(state); 
        } else {
            await this.initialize(); 
        }
    }

    componentDidUpdate = async () => {}   

    render = () => {

        let { Action, Searchs, DataTable, Inputs, ReadOnlys, InputGroup, Masterbase, Deletes, Operation, Approved, Token } = this.state;

        let AppProps = constants.AppProps[helper.getCurrentRoute()];

        return (
            <>
                <Container>

                    <CommonPageHeader object={AppProps}/>

                    <CommonTokenExpired Token={Token} />

                    <CommonPreviewFileModal
                        Action={Action}
                        onClose={() => Actions.handleClosePreviewFile(this.updateState)}
                    />

                    <CommonToolbar 
                        config={AppProps.toolbar}
                        
                        Operation={Operation}
                        Deletes={Deletes}

                        onToggleSearch={(e) => Actions.handleToggleItem(this.updateState, 'Operation', 'Search')}

                        onRefreshDataTable={async (e) => await this.loadDataTable()}
                        
                        // onPrintItem={(e) => this.exportExcel()}

                        onCreateItem={(e) => Actions.handleOpenInputForm(this.updateState, 'OffCanvas', 'new', true, this.setDefaultInputs)}
                        onModalAction={(e) => Actions.handleControlModal(this.updateState, e)}
                    />

                    <CommonToast 
                        toast={Action.Toast} 

                        onCloseToast={(e) => Actions.handleCloseToast(this.updateState)}
                    />

                    <CommonConfirmModal 
                        Action={Action}
                        Deletes={Deletes}

                        onCallback={async (e) => { 
                            let result = await Actions.handleControlModal(this.updateState, e);
                            if(result.action){
                                if (result.section === 'Delete'){ await this.deleteData(); }
                            }
                         }}
                    />

                    <SearchEB01DataCourse 
                        Action={Action}
                        Searchs={Searchs}
                        InputGroup={InputGroup}
                        Masterbase={Masterbase}
                        Operation={Operation}
                        UserCookie={userProfile}

                        onInputChange={(e, element) => Actions.handleInputChange(this.updateState, element, e)}

                        onSearch={async (e) => await this.loadDataTable(true)}
                    />

                    <DataTableEB01DataCourse 
                        Action={Action}
                        DataTable={DataTable}
                        Inputs={Inputs}
                        Deletes={Deletes}
                        Masterbase={Masterbase}
                        Operation={Operation}
                        UserCookie={userProfile}

                        onSetEdit={async (e, obj, approved = false) => { await this.fetchForEdit(obj, approved); }}
                        onNavigate={(e, obj) => this.navigate(e, obj)}
                        onDropDownChange={async(e, element, pk) => { await this.updateSomething(e, element, pk)} }

                        onCheckDelete={(e) => Actions.handleDataTableToggleDelete(this.updateState, e)}
                        onCheckDeleteAll={(e, deletes) => Actions.handleDataTableToggleDeleteAll(this.updateState, e, deletes)}
                        onPaginationChange={(paging) => Actions.handleDataTablePaginationChange(this.updateState, paging, this.loadDataTable)}
                    />

                    <InputEB01DataCourse 
                        URL={URL}
                        
                        App={AppProps}

                        Action={Action}
                        Inputs={Inputs}
                        ReadOnlys={ReadOnlys}
                        InputGroup={InputGroup}
                        Masterbase={Masterbase}
                        Operation={Operation}
                        Approved={Approved}
                        UserCookie={userProfile}

                        onUpdateState={(key, value) => Actions.updateState(this.updateState, key, value)}
                        onInputChange={(e, element) => Actions.handleInputChange(this.updateState, element, e)}
                        
                        onPreviewFile={(e) => Actions.handlePreviewFile(this.updateState, e)}
                        onDeleteFile={(field, pk) => Actions.deleteFile(this.updateState, URL, field, pk)}
                        
                        onCloseAlert={(e) => { Actions.handleCloseAlert(this.updateState, 'Alert', e); }}
                        onSubmit={async (e) => { await this.submitData()}}

                        onGenerateCourseCode={async (e) => { await this.generateCourseCode(e); }  }
                        
                        onDiscardSubmit={(e) => { Actions.handleDiscardInputs(this.updateState, 'Inputs'); }}
                        onClose={(e) => {
                                Actions.handleDiscardInputs(this.updateState, 'Inputs');
                                Actions.handleCloseInputForm(this.updateState, 'OffCanvas')
                            }
                        }
                    />
                </Container>
            </>
        )
    }
}

export default withRouter(EB01DataCourse);